import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import Grid24 from '../../../../components/UI/Grid24';
import { loadingInspecaoProcessoController } from '../../loadingInspecaoProcessoController';
import { enviarMemoriaDeCalculoPorEmailAction, imprimirMemoriaDeCalculoAction } from '../../../../store/Global/LoadSelectors/loadSelectors.saga';

function DialogMemoriaDeCalculo({
  onClose, setLoadings, idProcesso,
}) {
  const dispatch = useDispatch();

  const imprimirMemoriaDeCalculo = useCallback(() => () => {
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(true));
    dispatch(imprimirMemoriaDeCalculoAction(idProcesso));
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(false));
    onClose();
  }, [setLoadings, idProcesso, dispatch, onClose]);

  const enviarMemoriaDeCalculo = useCallback(() => () => {
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(true));
    dispatch(enviarMemoriaDeCalculoPorEmailAction(idProcesso));
    setLoadings(loadingInspecaoProcessoController.changeLoadingTitulos(false));
    onClose();
  }, [setLoadings, idProcesso, dispatch, onClose]);


  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        <span>Você pode imprimir o relatório de Memória de Cálculo ou enviá-lo por e-mail ao devedor. Qual ação deseja realizar?</span>
      </Grid24>


      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
        <Button
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          onClick={imprimirMemoriaDeCalculo()}
        >
          Imprimir
        </Button>
        <Button
          onClick={enviarMemoriaDeCalculo()}
        >
          Enviar e-mail
        </Button>
      </div>
    </>
  );
}
export default DialogMemoriaDeCalculo;
